import styled from "styled-components"

export const MainBoard = styled.div<{ isLoading: boolean }>`
  position: absolute;
  z-index: -1;
  top: 0;
`
